import { ChangeEvent, useCallback, useState } from "react";
import { toast } from "react-toastify";
import { Button, Card, CardBody, Col, Row, TabContent, TabPane } from "reactstrap";
import { Previous, VerticalValidationWizardTitle } from "../../../../../../constants";
import { VerticalValidationWizardSubTitle } from "../../../../../../data/formsAndTable/forms/FormLayout";
import CartInfoForm from "./CartInfoForm";
import NetBankingForm from "./NetBankingForm";
import VerticalWizardNav from "./VerticalWizardNav";
import YourInfoForm from "./YourInfoForm";
import { WizardForm } from "../../../../../../types/Forms";
import { useForm } from "react-hook-form";
import CommonCardHeader from "../../../../../../coreComponents/CommonCardHeader";

const VerticalValidationWizard = () => {
  const [steps, setSteps] = useState(1);
  const [showFinish, setShowFinish] = useState(false);
  const {
    register,
    formState: { errors },
    setValue,
    watch,
    trigger,
  } = useForm<WizardForm>({});

  const formData = watch();
  const activeCallBack = useCallback((tab: number) => setSteps(tab), []);
  const updateFormData = (event: ChangeEvent<HTMLInputElement>) => {
    const name = event.target.name;
    let value: string | boolean = "";

    if (event.target.type === "checkbox") {
      value = event.target.checked;
    } else if (event.target.type === "file") {
      value = event.target.files?.[0]?.name || "";
    } else {
      value = event.target.value || "";
    }

    setValue(name as keyof WizardForm, value as string, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const handleFinishButton = () => {
    return toast.success("Successfully Completed");
  };

  const handleNextButton = async () => {
    let fieldsToValidate: (keyof WizardForm)[] = [];
    if (steps === 1) {
      fieldsToValidate = ["firstName", "lastName", "contact", "email", "state", "zip"];
    } else if (steps === 2) {
      fieldsToValidate = ["recipientUserName", "userName", "cardNumber", "expirationDate", "cvvNumber", "documentationName"];
    } else if (steps === 3) {
      fieldsToValidate = ["bankName", "feedBack"];
    }
    const isValid = await trigger(fieldsToValidate); //Use trigger to validate only the fields for the current step instead of the entire form.
    if (isValid) {
      setSteps((prevStep) => prevStep + 1);
      if (steps === 3) setShowFinish(true);
    } else {
      toast.error("Please fill out all the fields before moving on to the next step");
    }
  };

  return (
    <Col md="12">
      <Card>
        <CommonCardHeader title={VerticalValidationWizardTitle} span={VerticalValidationWizardSubTitle} />
        <CardBody>
          <div className="vertical-main-wizard">
            <Row className="g-3">
              <Col xxl="3" xl="4" xs="12">
                <VerticalWizardNav steps={steps} activeCallBack={activeCallBack} />
              </Col>
              <Col xxl="9" xl="8" xs="12">
                <TabContent activeTab={steps}>
                  <TabPane tabId={1}>
                    <YourInfoForm register={register} errors={errors} formData={formData} updateFormData={updateFormData} />
                  </TabPane>
                  <TabPane tabId={2}>
                    <CartInfoForm register={register} errors={errors} formData={formData} updateFormData={updateFormData} />
                  </TabPane>
                  <TabPane tabId={3} className="custom-input">
                    <NetBankingForm register={register} errors={errors} formData={formData} updateFormData={updateFormData} />
                  </TabPane>
                </TabContent>
                <Col xs="12" className="text-end">
                  {steps === 2 && (
                    <Button onClick={() => activeCallBack(1)} color="primary" className="me-1">
                      {Previous}
                    </Button>
                  )}
                  <Button color={showFinish ? "success" : "primary"} onClick={showFinish ? handleFinishButton : handleNextButton}>
                    {showFinish ? "Finish" : "Next"}
                  </Button>
                </Col>
              </Col>
            </Row>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};
export default VerticalValidationWizard;
